import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import ConocimientosPreviosCardImg from "../../components/UmmIApps/Cards/ConocimientosPreviosCardImg.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const ConocimientosPreviosPage = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    handleBack,
    mostrarCamposAvanzados,
    toggleCamposAvanzados,
    setTextoInicial,
    isOAAdded,
    handleInitialPromptData,
    handleNivelChange,
    handleAsignaturaChangeLocal,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema &&
    isOAAdded
  );
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      tema: "",
      nivel: "",
      materia: "",
      objetivos: [],
      adaptaciones_curriculares: "",
      condiciones_contexto: "",
      caracterizacion: "",
    };
    handleInitialPromptData(init, "conocimientos_previos");
    setTextoInicial(
      "A continuación te proponemos 4 posibles actividades, 2 enfocadas en el levantamiento de conocimientos previos y 2 enfocadas en la integración de los conocimientos previos con los contenidos nuevos para favorecer el aprendizaje de tus estudiantes. Puedes elegir y editar cualquiera de las opciones según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ConocimientosPreviosCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        titleColor="#BA4534"
        title="Activación de conocimientos previos"
        description="Crea puentes entre lo que tus alumnos ya saben y lo que están a punto de aprender, facilitando una comprensión más sólida de los contenidos"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3 }}>
          <TemaClase />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>

        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12}>
              <Caracterizacion />
            </Grid>
            <Grid item xs={12}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default ConocimientosPreviosPage;
